import { axiosClient } from 'src/services/axiosInstance'

import { getCookie } from '../cookies'

export async function setDyIdServer() {
  try {
    const dyid = getCookie('_dyid')

    if (!dyid) {
      return
    }

    const { data } = await axiosClient.post(
      '/api/account/setDyIdServer',
      {},
      {
        withCredentials: true,
      }
    )

    if (!data.success) {
      return console.error('Erro ao setar cookie:', data.message)
    }

    return data.success
  } catch (error) {
    console.error('Erro na requisição:', error)
  }
}
